import { SWRConfiguration } from 'swr';

export const getBaseSWRConfig = (): SWRConfiguration => ({
  // Should not re-fetch data on focus
  revalidateOnFocus: false,
  // Should re-fetch data on mount
  revalidateOnMount: true,
  // Default is 2000ms (2 seconds) => refetch on a shorter interval
  dedupingInterval: 500,
});
